import React, { useState } from "react";
import { Box, Typography, Divider, Button, useTheme } from "@mui/material";
import NotificationModal from "../../notificationModal/notificationModal";
import Cookies from "js-cookie";
import axios from "axios";

const SurveyNotification = () => {
  const [open, setOpen] = useState(() => {
    return Cookies.get("surveyHidden") !== "yes";
  });
  const theme = useTheme();

  const hideSurveyForYear = () => {
    Cookies.set("surveyHidden", "yes", { expires: 365 });
  };
  const handleAnswer = async (answer: boolean) => {
    // Close the modal immediately
    setOpen(false);
    hideSurveyForYear();

    try {
      // Send feedback in the background
      await axios.post("https://absence-feedback-api.vercel.app/feedback", {
        answer,
      });
    } catch (err) {
      console.error("Failed to submit feedback", err);
    }
  };

  const handleWhatsAppClick = async () => {
    try {
      await axios.post(
        "https://absence-feedback-api.vercel.app/whatsappClicked"
      );
    } catch (err) {
      console.error("Failed to register WhatsApp click", err);
    }
  };

  if (!open) return null;

  return (
    <NotificationModal closeModal={open}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          display: "flex",
          flexDirection: "column",
          transform: "translate(-50%, -50%)",
          width: 800,
          background: theme.palette.common.newBylawColor,
          borderRadius: "10px",
          minHeight: "60%",
          overflowY: "auto",
          outline: 0,
          boxShadow: 24,
          p: 4,
          "@media screen and (max-width: 768px)": {
            width: "80%",
            height: "500px",
          },
        }}
      >
        <Typography
          sx={{ fontSize: "30px", fontWeight: 700, alignSelf: "center" }}
        >
          Quick Survey
        </Typography>

        <Typography
          sx={{
            fontSize: "50px",
            fontWeight: 600,
            mb: 2,
            alignSelf: "center",
            textAlign: "center",
          }}
        >
          Is the tool useful for you ?
        </Typography>

        <Divider sx={{ mb: 3 }} />

        {/* FULL-WIDTH BUTTONS */}
        <Box sx={{ display: "flex", width: "100%", gap: 2, mb: 4 }}>
          <Button
            onClick={() => handleAnswer(true)}
            sx={{
              flex: 1,
              height: "50px",
              background: theme.palette.common.acceptGreen,
              color: theme.palette.common.white,
              fontWeight: 700,
              fontSize: "16px",
              ":hover": { background: theme.palette.common.acceptGreenHover },
            }}
          >
            Yes
          </Button>

          <Button
            onClick={() => handleAnswer(false)}
            sx={{
              flex: 1,
              height: "50px",
              background: theme.palette.error.main,
              color: theme.palette.common.white,
              fontWeight: 700,
              fontSize: "16px",
              ":hover": { background: theme.palette.error.dark },
            }}
          >
            No
          </Button>
        </Box>

        {/* CONTACT CREATOR */}
        <Typography sx={{ fontSize: "28px", fontWeight: 700 }}>
          Contact Creator
        </Typography>

        <Typography sx={{ fontSize: "22px", mt: 1 }}>
          For suggestions or complaints, you can reach out directly via{" "}
          <a
            href="https://wa.me/201157343612"
            onClick={handleWhatsAppClick}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: theme.palette.primary.main, fontWeight: 600 }}
          >
            WhatsApp
          </a>
        </Typography>
      </Box>
    </NotificationModal>
  );
};

export default SurveyNotification;
